import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiResult } from '../../models/ApiResult';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { LocalizationService } from '../../services/localization.service';
import { InmRelTasTestigoService } from '../../services/inm-rel-tas-testigo.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { INMTasacionesComponent } from '../inmtasaciones/inmtasaciones.component';
import { AuthService } from '../../services/auth.service';
import { TestigosEditComponent } from '../testigos-edit/testigos-edit.component';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { RelTasTestigo } from '../../models/RelTasTestigo';
import { ModelHelpers } from '../../models/ModelHelpers';

@Component({
  selector: 'app-inm-rel-tas-testigo',
  templateUrl: './inm-rel-tas-testigo.component.html',
  styleUrls: ['./inm-rel-tas-testigo.component.scss']
})
export class InmRelTasTestigoComponent implements OnInit {

  relForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  tasacionId: number;
  testigoId: number;
  isModal: boolean;
  errorMessage: String = '';
  localization: LocalizationService;
  testigosEditMod: MatDialogConfig;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _relaService: InmRelTasTestigoService,
    public dialogRef: MatDialogRef<InmRelTasTestigoComponent>, private _location: Location, localization: LocalizationService, public _authService: AuthService, private _dialog: MatDialog,
    public dateHelper: DateHelper,) {

      this.testigosEditMod = new MatDialogConfig();
      this.testigosEditMod.disableClose = false;
      this.testigosEditMod.autoFocus = true;
      this.testigosEditMod.closeOnNavigation = true;
      this.testigosEditMod.disableClose = true;

      this.localization = localization;

      if (this._avRoute.snapshot.params['id']) {
        this.id = this._avRoute.snapshot.params['id'];
      }else{
        this.id = 0;
      }

      this.relForm = this._fb.group({
        id: 0,
        tasacionId: [''],
        testigoId: [''],
        observaciones: [''],
        a: [0, Validators.required],
        b: [0, Validators.required],
        c: [0, Validators.required],
        d: [0, Validators.required],
        e: [0, Validators.required],
        f: [0, Validators.required],
      });
    }

  ngOnInit() {
    if(this.id > 0){
      this.isNewElement = false;
      this.title = 'Editar';
      this._relaService.getRelacion(this.id)
        .subscribe((resp:RelTasTestigo) => {
          console.log(resp)
          this.relForm.setValue(resp);
          this.testigoId = this.relForm.controls['testigoId'].value
        }, error => {
          this.errorMessage = error;
        });
    }else{
      this.isNewElement = true;
      this.relForm.controls['tasacionId'].setValue(this.tasacionId);
      this.relForm.controls['testigoId'].setValue(this.testigoId);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  onSaved(value: ApiResult | null) {
    if (value.correct) {
      if (!this.isModal) {
        this._location.back();
      } else {
        this.closeDialog();
      }
    } else {
      if (value !== null) {
        this.errorMessage = value.mensaje;
      } else {
        this.errorMessage = 'Error interno';
      }
    }
  }

  save() {
    if (!this.relForm.valid) {
      return;
    }

    let relModel = new RelTasTestigo();
    ModelHelpers.copyFromForm(this.relForm.value, relModel);

    if (this.isNewElement) {
      this._relaService.postReal(relModel)
        .subscribe({
          next: (value) => {
            this.onSaved(value);
          },
          error: (err) => {
            console.log(err);
            this.onSaved(null);
          }
        });
    }else{
      this._relaService.updateRel(relModel)
      .subscribe({
          next: (value) => {
            this.onSaved(value);
          },
          error: (err) => {
            console.log(err);
            this.onSaved(null);
          }
        }
      );
    }
  }

  editTestigo(idTestigo){
    const dlgRef = this._dialog.open(TestigosEditComponent, this.testigosEditMod);
    dlgRef.componentInstance.id = idTestigo;
    dlgRef.componentInstance.isModal = true;
  }

  get a() { return this.relForm.get('a'); }
  get b() { return this.relForm.get('b'); }
  get c() { return this.relForm.get('c'); }
  get d() { return this.relForm.get('d'); }
  get e() { return this.relForm.get('e'); }
  get f() { return this.relForm.get('f'); }
}
